import { FormikProps } from "formik";

export type LoginFormData = {
  emailAddress: string;
  password: string;
  oneTimePassword: string;
};

export enum LoginFormSteps {
  EmailAddress,
  Password,
  TwoFactorAuth,
}

export type LoginStepProps = {
  currentStep: LoginFormSteps;
  formikProps: FormikProps<LoginFormData>;
  onInputChange: () => void;
};
